























































































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import MensagemDoChatDeSuporte from './MensagemDoChatDeSuporte.vue'
import TextoRicoDoChat from './TextoRicoDoChat.vue'
import { ChatDeSuporteModule, sessaoVivaDe } from '@/store/vuex/suporte/ChatDeSuporteStore'
import { apiDoChatDeSuporte, ErroDoChatDeSuporte, novoClientId } from '@/api/suporteChat'
import {
	diaDaMensagem,
	erroAnexadoRecusado,
	ID_DO_BOTAO_DE_PRINT,
	opcaoEscolhida,
	situacaoDoAtendimento,
	TAMANHO_MAXIMO_DO_ANEXO,
	TEXTO_DO_ERRO_ANEXADO,
	TIPOS_DE_ANEXO,
} from '@/shareds/chat-de-suporte'

type Pendente = {
	localId: string
	texto: string
	status: 'enviando' | 'falhou'
	messageId?: number
	arquivo?: File
	previa?: string
	/** Id do erro anexado (diálogo de detalhes do erro). */
	erroAnexado?: string
}

const ALTURA_MAXIMA_DO_CAMPO = 132

@Component({
	components: {
		MensagemDoChatDeSuporte,
		TextoRicoDoChat,
	},
})
export default class PainelDoChatDeSuporte extends Vue {
	@Ref() lista?: HTMLElement
	@Ref() campo?: HTMLTextAreaElement
	@Ref() arquivo?: HTMLInputElement

	texto = ''
	pendentes: Pendente[] = []
	aviso: string | null = null
	respondendo: string | null = null
	imagemAberta: string | null = null
	tiposDeAnexo = TIPOS_DE_ANEXO.join(',')

	get itens() {
		return ChatDeSuporteModule.itens
	}

	get estado() {
		return ChatDeSuporteModule.estado
	}

	get fase() {
		return ChatDeSuporteModule.fase
	}

	get semConexao() {
		return ChatDeSuporteModule.semConexao
	}

	get situacao() {
		return situacaoDoAtendimento(this.estado)
	}

	get digitando() {
		return !!this.estado && !!this.estado.typing
	}

	get pronto() {
		return this.fase.tipo === 'pronto' && !!ChatDeSuporteModule.sessionToken
	}

	get podeEnviar() {
		return this.pronto && !!this.texto.trim()
	}

	get primeiroNome() {
		return ChatDeSuporteModule.nome.trim().split(/\s+/)[0] || ''
	}

	get quantidadeNaTela() {
		return this.itens.length + this.pendentes.length + (this.digitando ? 1 : 0)
	}

	get erroAnexado() {
		return ChatDeSuporteModule.erroAnexado
	}

	mounted() {
		this.rolarParaOFim()
		this.focarCampo()
		this.enviarErroAnexado()
	}

	beforeDestroy() {
		this.pendentes.forEach(pendente => this.liberarPrevia(pendente))
	}

	@Watch('quantidadeNaTela')
	aoMudarConversa() {
		this.rolarParaOFim()
	}

	@Watch('pronto')
	aoFicarPronto(pronto: boolean) {
		if (!pronto) return
		this.focarCampo()
		this.enviarErroAnexado()
	}

	@Watch('erroAnexado')
	aoAnexarErro() {
		this.enviarErroAnexado()
	}

	// A mensagem otimista some quando a de verdade chega no polling.
	@Watch('itens')
	aoChegarMensagens() {
		const ids = new Set(this.itens.map(mensagem => mensagem.id))
		const confirmadas = this.pendentes.filter(pendente => pendente.messageId != null && ids.has(pendente.messageId))
		if (!confirmadas.length) return
		confirmadas.forEach(pendente => this.liberarPrevia(pendente))
		this.pendentes = this.pendentes.filter(pendente => !confirmadas.includes(pendente))
	}

	mostraDia(indice: number) {
		const anterior = this.itens[indice - 1]
		return !anterior || diaDaMensagem(anterior.sentAt) !== diaDaMensagem(this.itens[indice].sentAt)
	}

	dia(data: string) {
		return diaDaMensagem(data)
	}

	escolhida(indice: number) {
		return opcaoEscolhida(this.itens, indice)
	}

	aoApertarEsc() {
		if (this.imagemAberta) this.imagemAberta = null
		else this.$emit('minimizar')
	}

	enviarDoCampo() {
		const texto = this.texto.trim()
		if (!texto || !this.pronto) return
		this.texto = ''
		this.$nextTick(() => this.ajustarAltura())
		this.enviarTexto(texto)
	}

	reenviar(pendente: Pendente) {
		if (pendente.erroAnexado) this.enviarComErroAnexado(pendente.erroAnexado, pendente.localId)
		else if (pendente.arquivo) this.enviarArquivo(pendente.arquivo, pendente.localId)
		else this.enviarTexto(pendente.texto, pendente.localId)
	}

	/**
	 * O erro do diálogo de detalhes vai sozinho, assim que a sessão estiver viva: a pessoa vê o texto padrão do suporte
	 * como mensagem dela, e o atendente recebe o erro inteiro anexado. Sessão vencida espera a nova, porque o anexo
	 * só vale uma vez.
	 */
	enviarErroAnexado() {
		const reportId = ChatDeSuporteModule.erroAnexado
		if (!reportId || !this.pronto || !sessaoVivaDe(ChatDeSuporteModule.dono)) return
		ChatDeSuporteModule.anexarErro(null)
		this.enviarComErroAnexado(reportId)
	}

	async enviarComErroAnexado(reportId: string, localId = novoClientId()) {
		this.colocarPendente({ localId, texto: TEXTO_DO_ERRO_ANEXADO, status: 'enviando', erroAnexado: reportId })
		try {
			const sessao = this.sessaoParaEscrever()
			const contexto = ChatDeSuporteModule.contexto
			const resposta = await apiDoChatDeSuporte.enviar(sessao, {
				clientId: localId,
				errorReport: reportId,
				...(contexto ? { context: contexto } : {}),
			})
			if (contexto) ChatDeSuporteModule.usarContexto()
			this.confirmarPendente(localId, resposta.messageId)
		} catch (erro) {
			if (erro instanceof ErroDoChatDeSuporte && erroAnexadoRecusado(erro.status)) {
				// O anexo não serve mais (vencido, já usado, de outro usuário): a mensagem sai e o aviso do suporte fica
				this.pendentes = this.pendentes.filter(item => item.localId !== localId)
				this.aviso = erro.message
				return
			}
			this.falharPendente(localId, erro)
		}
	}

	async enviarTexto(texto: string, localId = novoClientId()) {
		this.colocarPendente({ localId, texto, status: 'enviando' })
		try {
			const sessao = this.sessaoParaEscrever()
			const contexto = ChatDeSuporteModule.contexto
			const resposta = await apiDoChatDeSuporte.enviar(sessao, {
				clientId: localId,
				text: texto,
				...(contexto ? { context: contexto } : {}),
			})
			if (contexto) ChatDeSuporteModule.usarContexto()
			this.confirmarPendente(localId, resposta.messageId)
		} catch (erro) {
			this.falharPendente(localId, erro)
		}
	}

	async enviarArquivo(arquivo: File, localId = novoClientId()) {
		const previa = arquivo.type.startsWith('image/') ? URL.createObjectURL(arquivo) : undefined
		this.colocarPendente({ localId, texto: arquivo.name, status: 'enviando', arquivo, previa })
		try {
			const sessao = this.sessaoParaEscrever()
			const destino = await apiDoChatDeSuporte.pedirEnvioDeArquivo(sessao, arquivo.type, arquivo.size)
			await apiDoChatDeSuporte.enviarArquivo(destino.url, arquivo.type, arquivo)
			const contexto = ChatDeSuporteModule.contexto
			const resposta = await apiDoChatDeSuporte.enviar(sessao, {
				clientId: localId,
				media: { s3Key: destino.s3Key, filename: arquivo.name },
				...(contexto ? { context: contexto } : {}),
			})
			if (contexto) ChatDeSuporteModule.usarContexto()
			this.confirmarPendente(localId, resposta.messageId)
		} catch (erro) {
			this.falharPendente(localId, erro)
		}
	}

	escolherArquivo() {
		if (this.arquivo) this.arquivo.click()
	}

	aoEscolherArquivo(evento: Event) {
		const input = evento.target as HTMLInputElement
		const arquivo = input.files && input.files[0]
		input.value = ''
		if (!arquivo) return
		if (!TIPOS_DE_ANEXO.includes(arquivo.type)) {
			this.aviso = 'Envie uma imagem (JPG ou PNG) ou um PDF.'
			return
		}
		if (arquivo.size > TAMANHO_MAXIMO_DO_ANEXO) {
			this.aviso = 'Arquivo acima de 10 MB. Escolha um arquivo menor.'
			return
		}
		this.aviso = null
		this.enviarArquivo(arquivo)
	}

	async escolher(replyId: string) {
		// No navegador não há captura de tela: o "Enviar print" do copiloto abre o seletor de arquivo
		if (replyId === ID_DO_BOTAO_DE_PRINT) {
			this.escolherArquivo()
			return
		}
		if (this.respondendo) return
		this.respondendo = replyId
		try {
			await apiDoChatDeSuporte.responder(this.sessaoParaEscrever(), novoClientId(), replyId)
			this.aviso = null
			this.$emit('consultar-agora')
		} catch (erro) {
			this.tratarErroDeEnvio(erro, 'Não foi possível enviar a opção. Tente de novo.')
		} finally {
			this.respondendo = null
		}
	}

	sessaoParaEscrever(): string {
		const sessao = ChatDeSuporteModule.sessionToken
		if (!sessao) throw new ErroDoChatDeSuporte(401, 'sem_sessao', 'Sessão do chat expirada.')
		return sessao
	}

	colocarPendente(pendente: Pendente) {
		const anterior = this.pendentes.find(item => item.localId === pendente.localId)
		if (anterior && anterior.previa !== pendente.previa) this.liberarPrevia(anterior)
		this.pendentes = [...this.pendentes.filter(item => item.localId !== pendente.localId), pendente]
	}

	confirmarPendente(localId: string, messageId: number) {
		this.pendentes = this.pendentes.map(item => (item.localId === localId ? { ...item, messageId } : item))
		this.aviso = null
		this.$emit('consultar-agora')
	}

	falharPendente(localId: string, erro: unknown) {
		this.pendentes = this.pendentes.map(item => (item.localId === localId ? { ...item, status: 'falhou' } : item))
		this.tratarErroDeEnvio(erro, 'Sem conexão com o chat. Confira a internet e clique na mensagem para tentar de novo.')
	}

	tratarErroDeEnvio(erro: unknown, semConexao: string) {
		if (erro instanceof ErroDoChatDeSuporte && erro.status === 401) {
			this.aviso = 'A sessão do chat venceu. Reconectando: clique na mensagem para tentar de novo.'
			this.$emit('sessao-vencida')
		} else if (erro instanceof ErroDoChatDeSuporte) {
			this.aviso = erro.message
		} else {
			this.aviso = semConexao
		}
	}

	liberarPrevia(pendente: Pendente) {
		if (pendente.previa) URL.revokeObjectURL(pendente.previa)
	}

	ajustarAltura() {
		const campo = this.campo
		if (!campo) return
		campo.style.height = 'auto'
		campo.style.height = `${Math.min(campo.scrollHeight, ALTURA_MAXIMA_DO_CAMPO)}px`
	}

	focarCampo() {
		this.$nextTick(() => {
			if (this.pronto && this.campo) this.campo.focus()
		})
	}

	rolarParaOFim() {
		this.$nextTick(() => {
			if (this.lista) this.lista.scrollTop = this.lista.scrollHeight
		})
	}
}
